import React from 'react';
import DOMPurify from 'dompurify';

const ConnectFormModal = ({
  show,
  onClose,
  availableForms,
  selectedFormToConnect,
  onSelectForm,
  onConnect,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Conectar Formularios</h2>
        <p className="mb-4">Selecciona el formulario que genera los IDs:</p>
        <select
          className="w-full p-2 border rounded mb-4"
          value={selectedFormToConnect}
          onChange={e => onSelectForm(e.target.value)}
        >
          <option value="">Seleccionar formulario</option>
          {availableForms.map(form => (
            <option key={form._id} value={form._id}>
              {DOMPurify.sanitize(form.formName, { ALLOWED_TAGS: [] })}
            </option>
          ))}
        </select>
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-gray-500 text-white rounded"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded"
            onClick={() => onConnect(selectedFormToConnect)}
          >
            Conectar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectFormModal;
